// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { CornerDownLeft } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCornerDownLeft(props: any) {
    return <IconBase icon={CornerDownLeft} {...props} />
  }

  export default IconCornerDownLeft
  